"use client";

import React from 'react';
import { Stack, Typography, List, ListItem, ListItemText, Divider, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PatientSearchResults = ({ patients, onSelectPatient }) => {
  const theme = useTheme();

  if (!patients || patients.length === 0) {
    return (
      <Stack sx={{ p: 3 }} alignItems="center" justifyContent="center">
        <Typography variant="body2" color="text.secondary">
          No patients found. Try a different search.
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ maxHeight: 300, overflowY: 'auto', border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
      <List disablePadding>
        {patients.map((patient, index) => (
          <React.Fragment key={patient.pid || index}>
            <ListItem
              button
              onClick={() => onSelectPatient(patient)}
              sx={{
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <ListItemText
                primary={
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                          {`${patient.first_name || ''} ${patient.last_name || ''}`.trim()}
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                          {`(ID: ${patient.pid})`}
                        </Typography>
                      </Stack>
                }
                sx={{ flexGrow: 1 }}
              />
            </ListItem>
            {index < patients.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default PatientSearchResults;